export class ToastMessages {

  public correctPinCode = 'toast.correct_pin_code';
  public error = 'toast.error';
  public folder = 'toast.folder';
  public incorrectPinCode = 'toast.incorrect_pin_code';
  public load = 'toast.load';
  public successTitle = 'toast.success_title';
  public warningContent = 'toast.warning_content';
  public warningTitle = 'toast.warning_title';
  public removePin = 'stepper.error_cert_remove';

  constructor() {
  }
}
